import React from "react"
import { graphql, Link, navigate } from "gatsby"

import { isExternal } from "../utils/url"

import { CardsFieldsFragment } from "../../graphql-types"
import formatPagePath from "../utils/format-page-path"
import replaceHyphenation from "../utils/replace-hyphenation"
import CallToAction from "./call-to-action"

export const query = graphql`
  fragment CardsFields on DatoCmsCard {
    componentId: key
    title
    cards {
      id
      title
      image {
        url(imgixParams: { w: "600" })
      }
      linkUrl
    }
    ctaLabel
    ctaLink
  }
`

const handleClick: React.MouseEventHandler<HTMLDivElement> = e => {
  if ((e.target as HTMLElement).tagName !== "A") {
    const href = (e.currentTarget as HTMLElement).getAttribute("data-faux-href")
    if (href) {
      if (isExternal(href)) {
        window.open(href, "_blank")
      } else {
        navigate(href)
      }
    }
  }
}

const Cards: React.FC<CardsFieldsFragment> = ({
  componentId,
  title,
  cards,
  ctaLabel,
  ctaLink,
}) => {
  return (
    <section
      id={componentId}
      className="c-cards o-wrapper o-row"
      data-faux-href="#"
    >
      <h2 className="c-content-header">{title}</h2>
      <div className="c-cards__items">
        {cards &&
          cards.map(item => {
            const image = item.image.url ? item.image.url : ""
            const href = isExternal(item.linkUrl)
              ? item.linkUrl
              : formatPagePath(item.linkUrl)
            return (
              <div
                key={item.id}
                className="c-card"
                data-faux-href={href}
                onClick={handleClick}
              >
                <div className="c-card__label">
                  <h3 className="c-heading--e">
                    {item.linkUrl ? (
                      <Link to={href}>{replaceHyphenation(item.title)}</Link>
                    ) : (
                      <>{item.title}</>
                    )}
                  </h3>
                </div>
                <div className="c-card__inner">
                  <img src={image} />
                </div>
              </div>
            )
          })}
      </div>
      {ctaLabel && ctaLink && (
        <div className="c-cards__cta">
          <CallToAction color="green" url={ctaLink}>
            {ctaLabel}
          </CallToAction>
        </div>
      )}
    </section>
  )
}

export default Cards
